<script lang="ts">
  import { fade, scale } from 'svelte/transition'
  import videoStore from '../../stores/video.svelte'
  import PlayIcon from './icons/PlayIcon.svelte'
  import PauseIcon from './icons/PauseIcon.svelte'

  type Props = {
    isPlayPauseTriggered: boolean
  }

  let { isPlayPauseTriggered = $bindable() }: Props = $props()

  $effect(() => {
    let triggerTimeout = null
    if (isPlayPauseTriggered) {
      triggerTimeout = setTimeout(() => {
        isPlayPauseTriggered = false
      }, 700)
    }

    return () => {
      if (triggerTimeout) {
        clearTimeout(triggerTimeout)
      }
    }
  })
</script>

{#if isPlayPauseTriggered && !videoStore.state.isMobileLayout}
  <span in:fade={{ delay: 50, duration: 150 }} out:fade={{ duration: 150 }}>
    <span
      class="w-24 h-24 p-2 rounded-[30px] flex items-center justify-center bg-black/20"
      style="fill: #FFFFFF"
      in:scale={{ duration: 200 }}
      out:scale={{ duration: 800 }}
    >
      {#if videoStore.state.isPlaying}
        <PlayIcon />
      {:else}
        <PauseIcon />
      {/if}
    </span>
  </span>
{/if}
